import clx from 'classnames';
import { useTranslation } from 'react-i18next';

type Props = {
  totalItems?: number;
  maxResults?: number | null;
  className?: string;
};

const TotalResults = ({ totalItems = 0, maxResults, className }: Props) => {
  const { t } = useTranslation();

  return (
    <p className={clx('text-neutral-600 md-regular', className)}>
      {maxResults && totalItems >= maxResults ? (
        <span>{t('list.header.totalResults.maxReached', { maxResults })}</span>
      ) : (
        <>
          <span className="md-bold mr-1">{totalItems || 0} </span>
          {t('list.header.totalResults', { count: totalItems || 0 })}
        </>
      )}
    </p>
  );
};

export default TotalResults;
